import {round} from "../utils/money";
import {BMI} from "../model/bmi.model";

export const bmiFactory = {
    create(sex, age, weight, height) {
        height = height / 100;
        const value = round(weight / (height * height), 2);
        const categories = this.getCategories(sex, age);
        const category = this.resolveCategory(categories, value);
        return new BMI(value, category, categories);
    },

    getCategories(sex, age) {
        age = age < 3 ? 3 : age;
        age = age > 18 ? 19 : age;
        const adultsBMI = [
            {
                from: 0,
                to: 16,
                name: 'starvation'
            },
            {
                from: 16,
                to: 17,
                name: 'emaciation'
            },
            {
                from: 17,
                to: 18.5,
                name: 'underweight',
            },
            {
                from: 18.5,
                to: 25,
                name: 'healthy',
            },
            {
                from: 25,
                to: 30,
                name: 'overweight',
            },
            {
                from: 30,
                to: 35,
                name: 'obese_1',
            },
            {
                from: 35,
                to: 40,
                name: 'obese_2',
            },
            {
                from: 40,
                to: Infinity,
                name: 'obese_3',
            }
        ];
        const BMI = {
            "male": {
                3: [
                    {
                        from: 0,
                        to: 14.3,
                        name: 'underweight'
                    },
                    {
                        from: 14.3,
                        to: 17.0,
                        name: 'healthy'
                    },
                    {
                        from: 17.0,
                        to: 19.3,
                        name: 'overweight'
                    },
                    {
                        from: 19.3,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                4: [
                    {
                        from: 0,
                        to: 13.9,
                        name: 'underweight'
                    },
                    {
                        from: 13.9,
                        to: 17.2,
                        name: 'healthy'
                    },
                    {
                        from: 17.2,
                        to: 19.7,
                        name: 'overweight'
                    },
                    {
                        from: 19.7,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                5: [
                    {
                        from: 0,
                        to: 13.8,
                        name: 'underweight'
                    },
                    {
                        from: 13.8,
                        to: 17.3,
                        name: 'healthy'
                    },
                    {
                        from: 17.3,
                        to: 20.4,
                        name: 'overweight'
                    },
                    {
                        from: 20.4,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                6: [
                    {
                        from: 0,
                        to: 13.8,
                        name: 'underweight'
                    },
                    {
                        from: 13.8,
                        to: 17.6,
                        name: 'healthy'
                    },
                    {
                        from: 17.6,
                        to: 21.3,
                        name: 'overweight'
                    },
                    {
                        from: 21.3,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                7: [
                    {
                        from: 0,
                        to: 13.8,
                        name: 'underweight'
                    },
                    {
                        from: 13.8,
                        to: 18.0,
                        name: 'healthy'
                    },
                    {
                        from: 18.0,
                        to: 22.4,
                        name: 'overweight'
                    },
                    {
                        from: 22.4,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                8: [
                    {
                        from: 0,
                        to: 14.0,
                        name: 'underweight'
                    },
                    {
                        from: 14.0,
                        to: 18.7,
                        name: 'healthy'
                    },
                    {
                        from: 18.7,
                        to: 23.8,
                        name: 'overweight'
                    },
                    {
                        from: 23.8,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                9: [
                    {
                        from: 0,
                        to: 14.3,
                        name: 'underweight'
                    },
                    {
                        from: 14.3,
                        to: 19.4,
                        name: 'healthy'
                    },
                    {
                        from: 19.4,
                        to: 25.2,
                        name: 'overweight'
                    },
                    {
                        from: 25.2,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                10: [
                    {
                        from: 0,
                        to: 14.5,
                        name: 'underweight'
                    },
                    {
                        from: 14.5,
                        to: 20.1,
                        name: 'healthy'
                    },
                    {
                        from: 20.1,
                        to: 26.6,
                        name: 'overweight'
                    },
                    {
                        from: 26.6,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                11: [
                    {
                        from: 0,
                        to: 14.8,
                        name: 'underweight'
                    },
                    {
                        from: 14.8,
                        to: 20.9,
                        name: 'healthy'
                    },
                    {
                        from: 20.9,
                        to: 27.7,
                        name: 'overweight'
                    },
                    {
                        from: 27.7,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                12: [
                    {
                        from: 0,
                        to: 15.3,
                        name: 'underweight'
                    },
                    {
                        from: 15.3,
                        to: 21.5,
                        name: 'healthy'
                    },
                    {
                        from: 21.5,
                        to: 28.4,
                        name: 'overweight'
                    },
                    {
                        from: 28.4,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                13: [
                    {
                        from: 0,
                        to: 15.7,
                        name: 'underweight'
                    },
                    {
                        from: 15.7,
                        to: 22.0,
                        name: 'healthy'
                    },
                    {
                        from: 22.0,
                        to: 28.6,
                        name: 'overweight'
                    },
                    {
                        from: 28.6,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                14: [
                    {
                        from: 0,
                        to: 16.3,
                        name: 'underweight'
                    },
                    {
                        from: 16.3,
                        to: 22.6,
                        name: 'healthy'
                    },
                    {
                        from: 22.6,
                        to: 28.8,
                        name: 'overweight'
                    },
                    {
                        from: 28.8,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                15: [
                    {
                        from: 0,
                        to: 16.7,
                        name: 'underweight'
                    },
                    {
                        from: 16.7,
                        to: 23.2,
                        name: 'healthy'
                    },
                    {
                        from: 23.2,
                        to: 28.9,
                        name: 'overweight'
                    },
                    {
                        from: 28.9,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                16: [
                    {
                        from: 0,
                        to: 17.4,
                        name: 'underweight'
                    },
                    {
                        from: 17.4,
                        to: 23.7,
                        name: 'healthy'
                    },
                    {
                        from: 23.7,
                        to: 29.2,
                        name: 'overweight'
                    },
                    {
                        from: 29.2,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                17: [
                    {
                        from: 0,
                        to: 17.9,
                        name: 'underweight'
                    },
                    {
                        from: 17.9,
                        to: 24.3,
                        name: 'healthy'
                    },
                    {
                        from: 24.3,
                        to: 29.6,
                        name: 'overweight'
                    },
                    {
                        from: 29.6,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                18: [
                    {
                        from: 0,
                        to: 18.5,
                        name: 'underweight'
                    },
                    {
                        from: 18.5,
                        to: 24.9,
                        name: 'healthy'
                    },
                    {
                        from: 24.9,
                        to: 30.0,
                        name: 'overweight'
                    },
                    {
                        from: 30.0,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                19: adultsBMI,
            },
            "female": {
                3: [
                    {
                        from: 0,
                        to: 14.5,
                        name: 'underweight'
                    },
                    {
                        from: 14.5,
                        to: 17.5,
                        name: 'healthy'
                    },
                    {
                        from: 17.5,
                        to: 19.8,
                        name: 'overweight'
                    },
                    {
                        from: 19.8,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                4: [
                    {
                        from: 0,
                        to: 14.1,
                        name: 'underweight'
                    },
                    {
                        from: 14.1,
                        to: 17.7,
                        name: 'healthy'
                    },
                    {
                        from: 17.7,
                        to: 20.3,
                        name: 'overweight'
                    },
                    {
                        from: 20.3,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                5: [
                    {
                        from: 0,
                        to: 13.9,
                        name: 'underweight'
                    },
                    {
                        from: 13.9,
                        to: 17.9,
                        name: 'healthy'
                    },
                    {
                        from: 17.9,
                        to: 20.8,
                        name: 'overweight'
                    },
                    {
                        from: 20.8,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                6: [
                    {
                        from: 0,
                        to: 13.8,
                        name: 'underweight'
                    },
                    {
                        from: 13.8,
                        to: 18.4,
                        name: 'healthy'
                    },
                    {
                        from: 18.4,
                        to: 21.8,
                        name: 'overweight'
                    },
                    {
                        from: 21.8,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                7: [
                    {
                        from: 0,
                        to: 14.0,
                        name: 'underweight'
                    },
                    {
                        from: 14.0,
                        to: 18.8,
                        name: 'healthy'
                    },
                    {
                        from: 18.8,
                        to: 22.7,
                        name: 'overweight'
                    },
                    {
                        from: 22.7,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                8: [
                    {
                        from: 0,
                        to: 14.2,
                        name: 'underweight'
                    },
                    {
                        from: 14.2,
                        to: 19.5,
                        name: 'healthy'
                    },
                    {
                        from: 19.5,
                        to: 23.8,
                        name: 'overweight'
                    },
                    {
                        from: 23.8,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                9: [
                    {
                        from: 0,
                        to: 14.5,
                        name: 'underweight'
                    },
                    {
                        from: 14.5,
                        to: 20.4,
                        name: 'healthy'
                    },
                    {
                        from: 20.4,
                        to: 25.0,
                        name: 'overweight'
                    },
                    {
                        from: 25.0,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                10: [
                    {
                        from: 0,
                        to: 14.8,
                        name: 'underweight'
                    },
                    {
                        from: 14.8,
                        to: 21.1,
                        name: 'healthy'
                    },
                    {
                        from: 21.1,
                        to: 26.5,
                        name: 'overweight'
                    },
                    {
                        from: 26.5,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                11: [
                    {
                        from: 0,
                        to: 15.3,
                        name: 'underweight'
                    },
                    {
                        from: 15.3,
                        to: 21.9,
                        name: 'healthy'
                    },
                    {
                        from: 21.9,
                        to: 27.7,
                        name: 'overweight'
                    },
                    {
                        from: 27.7,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                12: [
                    {
                        from: 0,
                        to: 15.8,
                        name: 'underweight'
                    },
                    {
                        from: 15.8,
                        to: 22.6,
                        name: 'healthy'
                    },
                    {
                        from: 22.6,
                        to: 28.5,
                        name: 'overweight'
                    },
                    {
                        from: 28.5,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                13: [
                    {
                        from: 0,
                        to: 16.4,
                        name: 'underweight'
                    },
                    {
                        from: 16.4,
                        to: 23.2,
                        name: 'healthy'
                    },
                    {
                        from: 23.2,
                        to: 28.0,
                        name: 'overweight'
                    },
                    {
                        from: 28.0,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                14: [
                    {
                        from: 0,
                        to: 16.8,
                        name: 'underweight'
                    },
                    {
                        from: 16.8,
                        to: 23.7,
                        name: 'healthy'
                    },
                    {
                        from: 23.7,
                        to: 29.3,
                        name: 'overweight'
                    },
                    {
                        from: 29.3,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                15: [
                    {
                        from: 0,
                        to: 17.2,
                        name: 'underweight'
                    },
                    {
                        from: 17.2,
                        to: 24.1,
                        name: 'healthy'
                    },
                    {
                        from: 24.1,
                        to: 29.5,
                        name: 'overweight'
                    },
                    {
                        from: 29.5,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                16: [
                    {
                        from: 0,
                        to: 17.8,
                        name: 'underweight'
                    },
                    {
                        from: 17.8,
                        to: 24.4,
                        name: 'healthy'
                    },
                    {
                        from: 24.4,
                        to: 29.7,
                        name: 'overweight'
                    },
                    {
                        from: 29.7,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                17: [
                    {
                        from: 0,
                        to: 18.2,
                        name: 'underweight'
                    },
                    {
                        from: 18.2,
                        to: 24.7,
                        name: 'healthy'
                    },
                    {
                        from: 24.7,
                        to: 29.8,
                        name: 'overweight'
                    },
                    {
                        from: 29.8,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                18: [
                    {
                        from: 0,
                        to: 18.4,
                        name: 'underweight'
                    },
                    {
                        from: 18.4,
                        to: 24.8,
                        name: 'healthy'
                    },
                    {
                        from: 24.8,
                        to: 29.9,
                        name: 'overweight'
                    },
                    {
                        from: 29.9,
                        to: Infinity,
                        name: 'obese'
                    }
                ],
                19: adultsBMI,
            }
        };
        return BMI[sex][age];
    },
    resolveCategory(categories, value) {
        return categories.find((category) => {
            return value >= category.from && value < category.to;
        });
    },
};